import { Connection } from 'vscode-languageserver';
import { WorkflowAPI } from '@gitlab-lsp/workflow-api';
import { ConfigService } from './config_service';
import { MessageHandler } from './message_handler';
import { TELEMETRY_NOTIFICATION } from './tracking/constants';
import { FeatureFlagService } from './feature_flags';
import { TelemetryTracker } from './tracking/tracking_types';
import { WebviewMetadataProvider } from './webview';
import { DuoProjectAccessCache } from './services/duo_access';
import { VirtualFileSystemService } from './services/fs/virtual_file_system_service';

export const START_WORKFLOW_NOTIFICATION = '$/gitlab/startWorkflow';
export const GET_WEBVIEW_METADATA_REQUEST = '$/gitlab/webview-metadata';

export function setup(
  telemetryTracker: TelemetryTracker,
  connection: Connection,
  featureFlagService: FeatureFlagService,
  configService: ConfigService,
  webviewMetadataProvider: WebviewMetadataProvider | undefined = undefined,
  workflowAPI: WorkflowAPI | undefined = undefined,
  duoProjectAccessCache: DuoProjectAccessCache,
  virtualFileSystemService: VirtualFileSystemService,
) {
  const messageHandler = new MessageHandler({
    telemetryTracker,
    connection,
    configService,
    featureFlagService,
    duoProjectAccessCache,
    workflowAPI,
    virtualFileSystemService,
  });

  connection.onDidChangeConfiguration(messageHandler.didChangeConfigurationHandler);

  connection.onNotification(TELEMETRY_NOTIFICATION, messageHandler.telemetryNotificationHandler);

  connection.onNotification(
    START_WORKFLOW_NOTIFICATION,
    messageHandler.startWorkflowNotificationHandler,
  );

  connection.onRequest(GET_WEBVIEW_METADATA_REQUEST, () => {
    return webviewMetadataProvider?.getMetadata() ?? [];
  });

  connection.onShutdown(messageHandler.onShutdownHandler);
}
